import classNames from 'classnames';
import { node, string } from 'prop-types';

import CloseButton from '~/components/ButtonIcons/CloseButton';
import PopupPlain, {
  propTypes as popupPlainPropTypes,
} from '~/components/PopupPlain';

import styles from './PopupMinimalistic.module.scss';

function PopupMinimalistic({
  buttonClassName,
  className,
  containerClassName,
  ...props
}) {
  return (
    <PopupPlain
      className={classNames(styles.modal, className)}
      containerClassName={classNames(styles.modalContainer, containerClassName)}
      Button={CloseButton}
      buttonClassName={classNames(styles.close, buttonClassName)}
      {...props}
    />
  );
}

export const propTypes = {
  children: node,
  containerClassName: string,
  className: string,
  ...popupPlainPropTypes,
};

PopupMinimalistic.propTypes = propTypes;

export default PopupMinimalistic;
